<template>

    <authentication-layout :title="title" :description="__('Type your email below')">

        <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
            {{ status }}
        </div>

        <validation-errors class="mb-4" />

        <form @submit.prevent="submit">

            <Input id="email"
                :placeholder="__('Email')"
                type="email"
                class="mt-1 block w-full"
                v-model="form.email" required autofocus />

            <div class="flex items-center justify-start mt-4 mb-12">
                <Button :class="{ 'opacity-25': form.processing }" :disabled="form.processing"
                >{{ __('Send Reset Link') }}</Button>
            </div>

            <Link class="text-xl"
                :href="route('login')"
            >← {{ __('Go back') }}</Link>

        </form>

    </authentication-layout>

</template>

<script>
    import { defineComponent } from 'vue'
    import { Head } from '@inertiajs/inertia-vue3';
    import AuthenticationLayout from "@/Layouts/AuthenticationLayout";
    import Button from '@/Components/Auth/Button.vue'
    import Input from '@/Components/Auth/Input.vue'
    import ValidationErrors from '@/Components/Auth/ValidationErrors.vue';
    import Link from "../../Components/Auth/Link";

    export default defineComponent({
        components: {
            Link,
            Head,
            AuthenticationLayout,
            Button,
            Input,
            ValidationErrors
        },

        props: {
            status: String
        },

        data() {
            return {
                form: this.$inertia.form({
                    email: ''
                })
            }
        },

        computed: {

            title() {
                return this.__('Forgot password?');
            }

        },

        methods: {
            submit() {
                this.form.post(this.route('password.email'))
            }
        }
    })
</script>
